import MarkdownText from './MarkdownText';

const renderPatternDetection = (data) => (
  <div className="pattern-detection">
    <div className="analysis-header bg-gradient-to-r from-primary/20 to-accent/20 p-6 rounded-lg border border-primary/30 mb-6">
      <h3 className="text-xl font-bold text-primary mb-2 flex items-center">
        🔍 Behavioral Pattern Analysis
      </h3>
      <div className="text-foreground"><MarkdownText>{data.analysis}</MarkdownText></div>
    </div>

    {data.patterns && data.patterns.length > 0 && (
      <div className="patterns-grid grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        {data.patterns.map((pattern, index) => (
          <div key={index} className="pattern-card bg-card rounded-lg border border-border shadow-sm overflow-hidden flex flex-col">
            {/* Card Header */}
            <div className={`px-5 py-3 flex items-center justify-between ${
              pattern.severity === 'high' ? 'bg-destructive/10 border-b border-destructive/20' :
              pattern.severity === 'medium' ? 'bg-yellow-500/10 border-b border-yellow-500/20' :
              'bg-primary/10 border-b border-primary/20'
            }`}>
              <h4 className="text-base font-semibold text-foreground">{pattern.title}</h4>
              <span className={`px-2.5 py-0.5 text-xs font-medium rounded-full shrink-0 ml-3 ${
                pattern.severity === 'high' ? 'bg-destructive/20 text-destructive' :
                pattern.severity === 'medium' ? 'bg-yellow-500/20 text-yellow-500' :
                'bg-primary/20 text-primary'
              }`}>
                {pattern.severity}
              </span>
            </div>

            {/* Card Body */}
            <div className="p-5 flex flex-col gap-3 flex-1">
              <p className="text-sm text-card-foreground leading-relaxed">{pattern.description}</p>

              {pattern.evidence && (
                <div className="bg-muted/50 p-3 rounded-md border border-border">
                  <div className="text-xs font-medium text-muted-foreground uppercase tracking-wide mb-1">Evidence</div>
                  <p className="text-sm text-muted-foreground">{pattern.evidence}</p>
                </div>
              )}

              <div className="bg-primary/5 p-3 rounded-md border border-primary/20 mt-auto">
                <div className="text-xs font-medium text-primary uppercase tracking-wide mb-1">💡 Recommendation</div>
                <p className="text-sm text-foreground">{pattern.recommendation}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    )}

    {data.follow_up_suggestions && data.follow_up_suggestions.length > 0 && (
      <div className="follow-up-suggestions mt-6">
        <h4 className="text-md font-semibold text-foreground mb-3">Explore further:</h4>
        <div className="flex flex-wrap gap-2">
          {data.follow_up_suggestions.map((suggestion, index) => (
            <button
              key={index}
              className="px-3 py-2 text-sm bg-primary/20 text-primary rounded-lg hover:bg-primary/30 transition-colors border border-primary/30"
            >
              {suggestion}
            </button>
          ))}
        </div>
      </div>
    )}
  </div>
);

export default renderPatternDetection;
